module.exports = __webpack_public_path__ + "static/media/calendar_grey.fd4e715d.png";